/**
 * Product Color Dots - Laoli Theme
 * Handles color dots for variant options based on custom.dot_color metafield
 */

/**
 * Parse color from dot_color metafield format "black-000" (after handle filter)
 * @param {string} dotColorValue - The value from custom.dot_color metafield
 * @returns {string|null} - Hex color code or null if invalid format
 */
function parseDotColor(dotColorValue) {
  
  if (!dotColorValue || typeof dotColorValue !== 'string') {
    return null;
  }
  
  // Handle new format: "black-000" -> extract color code
  if (dotColorValue.includes('-')) {
    const parts = dotColorValue.split('-');
    if (parts.length === 2) {
      const colorName = parts[0];
      const colorCode = parts[1];
      
      // Convert short hex to full hex if needed
      let fullHexCode;
      if (colorCode.length === 3) {
        // Convert "000" to "#000000"
        fullHexCode = '#' + colorCode.split('').map(c => c + c).join('');
      } else if (colorCode.length === 6) {
        // Convert "000000" to "#000000"
        fullHexCode = '#' + colorCode;
      } else {
        // Try to use as is
        fullHexCode = '#' + colorCode;
      }
      
      // Validate hex color format
      if (/^#[0-9A-Fa-f]{6}$/.test(fullHexCode)) {
        return fullHexCode;
      }
    }
  }
  
  // Fallback: try to find hex color with regex (for old format)
  const colorMatch = dotColorValue.match(/\{([^}]+)\}/);
  
  if (colorMatch && colorMatch[1]) {
    const colorCode = colorMatch[1].trim();
    
    // Check if it's a valid hex color
    if (/^#[0-9A-Fa-f]{3,6}$/.test(colorCode)) {
      return colorCode;
    }
  }
  
  return null;
}

/**
 * Create color dot element for variant options
 * @param {string} colorCode - Hex color code
 * @param {string} className - CSS class name for the dot
 * @returns {HTMLElement} - Color dot element
 */
function createColorDot(colorCode, className = 'laoli-pdp-color-dot') {
  
  if (!colorCode) {
    return null;
  }
  
  const dot = document.createElement('span');
  dot.className = className;
  dot.style.cssText = `
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${colorCode};
    flex-shrink: 0;
    margin-right: 8px;
    display: inline-block;
  `;
  
  return dot;
}

/**
 * Initialize color dots for variant options based on custom.dot_color metafield
 * This function should be called after the DOM is ready and variants are loaded
 */
function initColorDots() {
  // Find all variant menu items
  const allVariantItems = document.querySelectorAll(`
    .laoli-pdp-mobile-info-buttons-sizes-menu-item,
    .laoli-pdp-desktop-secondary-sizes-menu-item
  `);
  
  if (allVariantItems.length === 0) {
    return;
  }
  

  
  // Wait a bit more to see if values get updated
  setTimeout(() => {
    // Now process the items
    processColorDots(allVariantItems);
  }, 500);
}

/**
 * Process color dots for variant items
 */
function processColorDots(allVariantItems) {
  
  allVariantItems.forEach((item, index) => {
    
    // Check if item already has a color dot
    const existingDot = item.querySelector('.laoli-pdp-color-dot, .laoli-pdp-secondary-color-dot');
    if (existingDot) {
      return;
    }
    
    // Get variant ID to check metafields
    const variantId = item.getAttribute('data-id');
    if (!variantId) {
      return;
    }
    
    // Get dot_color from data attribute
    const dotColorValue = item.getAttribute('data-dot-color');
    
    if (dotColorValue) {
      const colorCode = parseDotColor(dotColorValue);
      
      if (colorCode) {
        const className = item.classList.contains('laoli-pdp-desktop-secondary-sizes-menu-item') ? 'laoli-pdp-secondary-color-dot' : 'laoli-pdp-color-dot';
        
        const colorDot = createColorDot(colorCode, className);
        if (colorDot) {
          // Insert dot at the beginning of the item
          item.insertBefore(colorDot, item.firstChild);
        }
      }
    }
  });
  

}

// Export for use in other scripts
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { initColorDots, parseDotColor, createColorDot };
}